import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Shown in place of Stripe checkout/billing UI inside the iOS App Store app.
// Copy must stay neutral (state unavailability only): naming or linking an
// external place to purchase violates App Store steering rules outside the US.
export default function NotAvailableInApp({ title, description }) {
  return (
    <div className="tw-bg-white dark:tw-bg-[#333F45] tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-xl tw-p-6 tw-text-center">
      <InfoOutlinedIcon
        className="tw-text-gray-400 dark:tw-text-gray-500"
        style={{ fontSize: 40 }}
      />
      <p className="tw-mt-2 tw-mb-0 tw-text-lg tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100">
        {title || 'Purchases are not available in this app'}
      </p>
      {description && (
        <p className="tw-mt-1 tw-mb-0 tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
          {description}
        </p>
      )}
    </div>
  );
}
